<template>
  <div>
    <h2 class="section-title training-h2">Training Center</h2>
    <section>
      <div class="training" v-if="showTraining">
        <h3>On-Demand Training</h3>
        <p>Access a series of self-paced training courses for Goalbook Toolkit.</p>
        <a class="training-link" @click="sendToLMS()">Launch On-Demand Training</a>
      </div>
    </section>
    <on-demand-training-error-modal :show-error-modal="showErrorModal" :on-close="closeModal"/>
  </div>
</template>

<script>
import { sendToLMS } from '@/api/auth'
import { mapState } from 'vuex'
import OnDemandTrainingErrorModal from '@/components/OnDemandTrainingErrorModal'

export default {
    name: 'OnDemandTraining',
    components: {
        OnDemandTrainingErrorModal,
    },
    computed: {
        ...mapState('user', {
          showTraining: state => !!state.user.show_training_button
        }),
    },
    data() {
        return {
            showErrorModal: false,
        }
    },
    methods: {
        async sendToLMS() {
            try {
                this.$sendEvent('Clicked On Demand Training Button', {ref: 'home'})
                await sendToLMS()
                this.$sendEvent('Logged Into On Demand Training')
            } catch (err) {
                this.$sendEvent('On Demand Training Login Failed')
                this.showErrorModal = true
            }
        },
        closeModal() {
            this.showErrorModal = false
        },
    },
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

// general styles
h3 {
    color: @header-text-dark;
    font-size: 1.2rem;
}
a:focus {
    outline: 2px solid lighten(@link-color, 20%);;
    outline-offset: 3px;
}
.section-title {
    text-transform: uppercase;
    font-size: 1rem;
}
.training {
    border: 1px solid @border-light-gray;
    background-color: @background-light-gray;
    padding: 0 1rem 1rem;
    margin-bottom: 1rem;
}
.training-h2 {
    margin-left: 1rem;
}
.training-link {
    cursor: pointer;
}
@media (max-width: @screen-xs) {
    .training {
        border: none;
        background: transparent;
    }
}
</style>
